export default __webpack_public_path__ + "static/media/download_green_icon.bba9157e.svg";